import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/home/home.component.ts